











































































































































































import CardHeader from "@/components/CardHeader.vue";
import {mapActions, mapState} from 'vuex'
import {CATEGORY, ROLE} from "@/plugins/Config"
import {Component, Vue} from 'vue-property-decorator'
import {GenderEnum, UserInterface} from "@/models/User";

@Component({
    computed:{
        ...mapState({
            users:(state: any) => state.user.users
        })
    },
    components:{
        CardHeader
    },
     data: () => ({
         search:'',
         headers: [
             {
                 text: 'Nombre(s)',
                 align: 'left',
                 sortable: true,
                 value: 'firstName',
             },
             {
                 text: 'Apellido(s)',
                 align: 'left',
                 sortable: true,
                 value: 'lastName',
             },

             {
                 text: 'Genero',
                 align: 'left',
                 sortable: true,
                 value: 'gender',
             },
             { text: 'E-mail', value: 'email' },
             { text: 'Rol', value: 'role' },
             { text: 'Categoria', value: 'category' },
             { text: 'Opciones', value: 'actions' },
         ],
     }),
    methods:{
        ...mapActions([
            "createUser", "editCollect", 'deleteCollect'
        ]),
    }
})
export default class User extends Vue {
    public dialog = false;
    public edit = false;
    public categories = CATEGORY;
    public roles = ROLE;
    public snackbar = false;
    public text = '';
    public idUser = '';
    public genders: string[] = ["MALE", "FEMALE"];
    public user: UserInterface = {
        firstName: '',
        lastName: '',
        role: '',
        email: '',
        category: '',
        password: '',
        gender: GenderEnum.MALE,
    };

    public rulesCategory = '';

    openModal(edit: boolean, item: UserInterface | any) {
        this.edit = edit;
        this.dialog = true;
        if (edit) {
            this.idUser = item.id;
            this.user = {
                firstName: item.firstName,
                lastName: item.lastName,
                role: item.role,
                email: item.email,
                category: item.category,
                password: '',
                gender: item.gender
            }
        } else {
            this.user = {
                firstName: '',
                lastName: '',
                role: '',
                email: '',
                category: '',
                password: '',
                gender: GenderEnum.MALE
            }
        }
    }
    formSubmit(){
        if (this.edit){
            this.$store.dispatch('editCollect', {id:this.idUser, collection: 'users', data:this.user});
            this.text = 'Se ha editado el usuario';
            this.dialog = false;
            this.snackbar = true;
        } else {
            this.$store.dispatch('createUser', this.user);
            this.text = 'Se ha creado el usuario';
            this.dialog = false;
            this.snackbar = true;
        }

    }
    chageRol(){
        if (this.user.role !== 'USER'){
            this.rulesCategory = '';
            this.user.category = ''
        }else {
            this.rulesCategory = 'required';
        }
    }
    deleteItem(item: any){
        this.$store.dispatch('deleteCollect', {id:item.id, collection:'users'})
    }
}

